import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { AuthShell } from "./Login";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setError("A senha deve ter pelo menos 8 caracteres.");
    if (pw !== pw2) return setError("As senhas não coincidem.");
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Nova senha" testid="admin-reset-page">
      {done ? (
        <div className="text-center space-y-6" data-testid="reset-success">
          <p className="text-zinc-300">Senha redefinida com sucesso.</p>
          <Link to="/admin/login" className="btn-gold w-full">Entrar</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label>Nova senha</Label>
            <Input data-testid="reset-input-password" type="password" autoComplete="new-password" value={pw} onChange={(e) => setPw(e.target.value)} className="admin-input" />
          </div>
          <div className="space-y-2">
            <Label>Confirmar nova senha</Label>
            <Input data-testid="reset-input-confirm" type="password" autoComplete="new-password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="admin-input" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="reset-error">{error}</p>}
          <button type="submit" disabled={busy || !token} data-testid="reset-submit-btn" className="btn-gold w-full h-12 disabled:opacity-60">
            {busy ? <Loader2 className="animate-spin" size={18} /> : "Salvar nova senha"}
          </button>
          {!token && <p className="text-sm text-red-400">Link inválido. Solicite um novo.</p>}
        </form>
      )}
    </AuthShell>
  );
}
